import {
  subscribeToAppointmentChanges,
  verifyAppointmentSubscription,
} from 'common-src/models/PatientIntegrationsAthena';

export const subscribeAndVerifyAppointmentChanges = (dispatch, showAlert, AlertType) => {
  dispatch(
    subscribeToAppointmentChanges(
      {
        eventname: 'ScheduleAppointment',
      },
      {
        successBlock: () => {
          showAlert(
            AlertType.Success,
            '',
            'Successfully subscribed to appointment changes. Verifying subscription...',
          );
          dispatch(
            verifyAppointmentSubscription(
              {},
              {
                successBlock: () => {
                  showAlert(AlertType.Success, '', 'Subscription verified! Status: Active');
                },
                errorBlock: (err) => {
                  showAlert(AlertType.Warning, '', `Subscribed but verification failed: ${err}`);
                },
              },
            ),
          );
        },
        errorBlock: (err) => {
          showAlert(AlertType.Error, '', `Failed to subscribe to appointment changes: ${err}`);
        },
      },
    ),
  );
};
